import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useConsentStore } from '../store/consentStore'

/**
 * Minimal RODO/ePrivacy cookie consent banner.
 *
 * Appears only until the user makes a choice. Two buttons: accept or reject
 * marketing/analytics tracking (Meta Pixel). The choice is stored in
 * localStorage and gates all custom Meta Pixel events.
 */
export default function CookieConsent() {
  const { t } = useTranslation()
  const { consent, initialize, accept, reject } = useConsentStore()

  useEffect(() => {
    initialize()
  }, [initialize])

  if (consent !== 'undecided') return null

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[70] bg-brand-blue text-white shadow-2xl"
      role="dialog"
      aria-live="polite"
      aria-label={t('cookieConsent.title', 'Zgoda na pliki cookie')}
    >
      <div className="max-w-6xl mx-auto px-4 py-4 md:py-5 flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm md:text-base leading-relaxed flex-1">
          {t(
            'cookieConsent.message',
            'Używamy narzędzi analitycznych i marketingowych (m.in. Meta Pixel), aby lepiej rozumieć, jak korzystasz z naszej strony. Kliknij „Akceptuję”, aby wyrazić zgodę, lub „Odrzuć”, aby używać strony bez dodatkowego śledzenia.'
          )}{' '}
          <Link
            to="/rodo"
            className="underline hover:text-brand-gold transition"
          >
            {t('cookieConsent.privacyLink', 'Więcej w Polityce Prywatności.')}
          </Link>
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={reject}
            className="px-4 py-2 rounded-full text-sm font-bold border border-white/30 hover:bg-white/10 transition"
          >
            {t('cookieConsent.reject', 'Odrzuć')}
          </button>
          <button
            type="button"
            onClick={accept}
            className="px-4 py-2 rounded-full text-sm font-bold bg-brand-gold text-brand-blue hover:bg-brand-gold/90 transition"
          >
            {t('cookieConsent.accept', 'Akceptuję')}
          </button>
        </div>
      </div>
    </div>
  )
}
